import { FC, ReactNode } from 'react'
import cn from './index.module.css'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import classNames from 'classnames'
import BasicTextField, {
  IBasicTextField,
} from '../BasicTextField/BasicTextField'

interface ITextField extends IBasicTextField {
  label?: ReactNode
  tooltip?: ReactNode
  description?: string
  extraContent?: ReactNode
  required?: boolean
}

const TextField: FC<ITextField> = ({
  label,
  tooltip,
  description,
  isInvalid,
  className,
  size,
  extraContent,
  required,
  ...props
}) => {
  return (
    <FieldWrapper
      label={label}
      tooltip={tooltip}
      description={description}
      isInvalid={isInvalid}
      extraContent={extraContent}
      required={required}
    >
      <BasicTextField
        className={classNames(
          cn.input,
          isInvalid && cn.invalid,
          size === 'small' && cn.smallSize,
          className,
        )}
        size={size}
        {...props}
      />
    </FieldWrapper>
  )
}

export default TextField
